import { useCallback, useEffect } from "react";
import { FirebaseAuthentication } from "@capacitor-firebase/authentication";
import { Capacitor } from "@capacitor/core";
import { dispatch } from "../../redux/store";
import {
  setUser,
  setUserAuthenticated,
  setAuthState,
} from "../../redux/actions/user";
import { auth } from "../../helpers/auth";
import useInitialData from "./useInitialData";

const useAuthenticate = () => {
  // Initial data listens for changes in idToken and will load initial data when this changes
  useInitialData();

  const registerUser = useCallback((user) => {
    const { uid, email, displayName } = user;
    dispatch(
      setUser({
        userId: uid,
        email,
        displayName,
      }),
    );
  }, []);

  // Set up auth listeners for future changes in auth state
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      FirebaseAuthentication.addListener("authStateChange", async (result) => {
        console.log("Auth state changed");
        const { user } = result;
        if (user) {
          registerUser(user);
          console.log("User is logged in");
        } else {
          dispatch(setUserAuthenticated(false));
          dispatch(setAuthState("unauthenticated"));
          dispatch(setUser(null));
          console.log("User is logged out");
        }
      });
    } else {
      auth.onAuthStateChanged(async (user) => {
        console.log("Auth state changed");
        if (user) {
          // User is signed in.
          registerUser(user);
          console.log("User is logged in");
        } else {
          dispatch(setUserAuthenticated(false));
          dispatch(setAuthState("unauthenticated"));
          dispatch(setUser(null));
          console.log("User is logged out");
        }
      });
    }
  }, []);
};

export default useAuthenticate;
